<button
  mat-icon-button
  aria-label="Parcours de découverte"
  matTooltip="Parcours de découverte"
  [matMenuTriggerFor]="toursMenu"
>
  <svg lucideCompass class="vanex-gold"></svg>
</button>

<ng-template #announcementLine let-entry>
  <span class="item">
    <span class="dot" [class.archived]="entry.announcement.archived"></span>
    <span class="text">
      <span class="item-title">{{ entry.title }}</span>
      <span class="item-subtitle">{{ entry.subtitle }}</span>
    </span>
    @if (!entry.announcement.archived) {
      <svg lucidePencil class="edit"></svg>
    }
  </span>
</ng-template>

<mat-menu #toursMenu="matMenu" class="tours-menu">
  @for (group of domains(); track group.domain) {
    <div class="section">{{ group.domain }}</div>
    @for (tour of group.tours; track tour.id) {
      <a mat-menu-item [href]="demoPathPrefix + tour.id" target="_blank" rel="noopener">
        <span>{{ tour.title }}</span>
        <svg lucideExternalLink [size]="14"></svg>
      </a>
    }
  } @empty {
    <div class="section">Aucun parcours</div>
  }

  @if (isDirection) {
    @let announcements = announcementItems();
    <mat-divider></mat-divider>
    @if (announcements.current.length) {
      <div class="section">Nouveautés</div>
      @for (entry of announcements.current; track entry.id) {
        <button mat-menu-item (click)="openAnnouncementDialog(entry.announcement)">
          <ng-container
            *ngTemplateOutlet="announcementLine; context: { $implicit: entry }"
          ></ng-container>
        </button>
      }
    }
    <button mat-menu-item class="announce" (click)="openAnnouncementDialog()">
      <svg lucideSparkles></svg>
      <span>Annoncer une nouveauté</span>
    </button>
    <button
      mat-menu-item
      [matMenuTriggerFor]="archivedAnnouncementsMenu"
      [disabled]="!announcements.archived.length"
    >
      <svg lucideArchive></svg>
      <span>Nouveautés archivées</span>
    </button>
  }
</mat-menu>

<mat-menu #archivedAnnouncementsMenu="matMenu" class="tours-menu">
  @for (entry of announcementItems().archived; track entry.id) {
    <button mat-menu-item (click)="openAnnouncementDialog(entry.announcement)">
      <ng-container
        *ngTemplateOutlet="announcementLine; context: { $implicit: entry }"
      ></ng-container>
    </button>
  }
</mat-menu>
